import { serverAddr } from "../networkConfig";

export default {
	getLocations({
		type = [
			"store",
			"warehouse",
			"central_kitchen",
			"head_office",
			"distribution_centre",
			"regional_office",
			"vendor"
		]
	} = {}) {
		return serverAddr.get(`outlet/location/?type=${type}`);
	},
	getClassification() {
		return serverAddr.get(`product/classification/`);
	},
	getDepartmentList(page) {
		return serverAddr.get(
			`product/classification/?page=${page.currentPage}/&page_size=${
				page.pageSize
			}`
		);
	},
	getArticleClassification() {
		return serverAddr.get(`/company/self/article-classification/`);
	},
	getCompanyData() {
		return serverAddr.get("/company/self/");
	},
	getLoggedinUserData() {
		return serverAddr
			.get(`/users/self/`)
			.then(respnse => JSON.parse(respnse.data));
	},
	getSummary(queryParams) {
		return serverAddr.post("/sales/summary/", queryParams);
	},
	getOutlets({
		fields = ["id", "name", "type"],
		get_all = true,
		type = [],
		not = ""
	} = {}) {
		return serverAddr.get(
			`/outlet/?fields=${fields}&get_all=${get_all}&type=${type}&not=${not}`
		);
	},
	getAllOutlets({
		fields = ["id", "name", "type"],
		get_all = true,
		type = [],
		not = ""
	} = {}) {
		return serverAddr.get(
			`/outlet/?fields=${fields}&get_all=${get_all}`
		);
	},
	getRegions(...args) {
		return serverAddr.get(`/outlet/region/?fields=${args}`);
	},
	getSubRegions() {
		return serverAddr.get(`/outlet/subregion/?get_all=true`);
	},
	getRegionsForParticularCountry(countryId, ...args) {
		return serverAddr.get(`/outlet/country/${countryId}/?fields=${args}`);
	},
	getSubregionsForParticularRegion(regionId, ...args) {
		return serverAddr.get(`/outlet/region/${regionId}/?fields=${args}`);
	},
	getCountries(...args) {
		return serverAddr.get(`/outlet/country/?fields=${args}`);
	},
	getCities({ get_all = true, fields = ["name", "id"] }) {
		return serverAddr.get(`/outlet/city/?fields=${fields}&get_all=${get_all}`);
	},
	isDataUpdated() {
		return serverAddr.get("/company/self/is-data-updated/");
	},
	getUsers({ get_all = false, fields = ["email", "first_name", "last_name"] }) {
		return serverAddr
			.get(`/users/?fields=${fields}&get_all=${get_all}`)
			.catch(err => {
				console.log(err);
			});
	},
	getCompanyConfig() {
		return serverAddr.get("/company/companyconfig/list/");
	},
};
